var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.828,
    height: 18.829,
    viewBox: "0 0 18.828 18.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2674",
    "data-name": "Group 2674",
    transform: "translate(-1692.586 -2463.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M6,21h5.333v5.333",
    transform: "translate(1705.333 2501.5) rotate(-180)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M26.333,11.333H21V6",
    transform: "translate(1731 2475.833) rotate(180)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M21,10.722,27.222,4.5",
    transform: "translate(1731 2475.222) rotate(180)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M4.5,27.222,10.722,21",
    transform: "translate(1704.722 2501.5) rotate(-180)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterFullScreen);
export default __webpack_public_path__ + "static/media/enter_full_screen.99fadd4e9ad760ea108ea42994cdf267.svg";
export { ForwardRef as ReactComponent };